import { Assets, BasePriceResult, FixedExpenses } from './modules/base-price-wizard';
import { CustomerList, AddCustomer, EditCustomer } from './modules/customers';
import { InvoicePaymentList, AddInvoicePayment, EditInvoicePayment, ViewInvoicePayment } from './modules/invoicePayments';
import { InvoiceList, AddInvoice, EditInvoice, ViewInvoice } from './modules/invoices';
import { RecurringInvoiceList, AddRecurringInvoice, EditRecurringInvoice, ViewRecurringInvoice } from './modules/recurring-invoices';
import { ProjectList, AddProject, EditProject } from './modules/projects';
import { ProposalList, AddProposal, EditProposal, ViewProposal } from './modules/proposals';
import { ServiceList, AddService, EditService } from './modules/services';
import { Settings } from './modules/settings';
import { DashboardView } from './modules/dashboards';
import { createRouter } from "./helpers";

export default createRouter([
	{ path: '/', component: DashboardView },
	{ path: '/base-price-wizard', component: FixedExpenses },
	{ path: '/base-price-wizard/assets', component: Assets },
	{ path: '/base-price-wizard/result', component: BasePriceResult },
	{ path: '/customers', component: CustomerList },
	{ path: '/customers/create', component: AddCustomer },
	{ path: '/customers/:id/edit', component: EditCustomer },
	{ path: '/receipts', component: InvoicePaymentList },
	{ path: '/receipts/create', component: AddInvoicePayment },
	{ path: '/receipts/:id/edit', component: EditInvoicePayment },
	{ path: '/receipts/:id/view', component: ViewInvoicePayment },
	{ path: '/invoices', component: InvoiceList },
	{ path: '/invoices/create', component: AddInvoice },
	{ path: '/invoices/:id/edit', component: EditInvoice },
	{ path: '/invoices/:id/view', component: ViewInvoice },
	{ path: '/recurring-invoices', component: RecurringInvoiceList },
	{ path: '/recurring-invoices/create', component: AddRecurringInvoice },
	{ path: '/recurring-invoices/:id/edit', component: EditRecurringInvoice },
	{ path: '/recurring-invoices/:id/view', component: ViewRecurringInvoice },
	{ path: '/projects', component: ProjectList },
	{ path: '/projects/create', component: AddProject },
	{ path: '/projects/:id/edit', component: EditProject },
	{ path: '/proposals', component: ProposalList },
	{ path: '/proposals/create', component: AddProposal },
	{ path: '/proposals/:id/edit', component: EditProposal },
	{ path: '/proposals/:id/view', component: ViewProposal },
	{ path: '/services', component: ServiceList },
	{ path: '/services/create', component: AddService },
	{ path: '/services/:id/edit', component: EditService },
	{ path: '/settings', component: Settings },
	{ path: '*', component: DashboardView },
])
